export const openInNewTab = (url: string) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.open(url, '_blank');
};
